module.exports = __webpack_public_path__ + "static/media/4_1.ddb8429a.png";